export const trackWPH = (action: string, options?: Record<string, unknown>) => {
  if (typeof window.wph === 'function') {
    window.WP.push(() => {
      window.WP.gdpr.runAfterConsent(() => {
        window.wph('track', action, options)
      })
    })
  }
}
